import { __decorate, __extends } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import InboundPlanAdd from './index.vue';

var InboundPlanEditPage = function (_super) {
  __extends(InboundPlanEditPage, _super);

  function InboundPlanEditPage() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  InboundPlanEditPage = __decorate([Component({
    components: {
      InboundPlanAdd: InboundPlanAdd
    }
  })], InboundPlanEditPage);
  return InboundPlanEditPage;
}(Vue);

export default InboundPlanEditPage;